import type { PageVille } from "@/data/villes";

const SITE = "https://tokamdarius.ca";

/**
 * Le graphe d'une page ville : Service, FAQPage, BreadcrumbList.
 *
 * LocalBusiness est volontairement absent. Declarer un commerce local par
 * ville reviendrait a annoncer quinze adresses qui n'existent pas, ce qui est
 * le motif exact d'une penalite de spam local. areaServed est la propriete
 * prevue pour un service rendu a distance, et schema-ville.test.ts le verifie.
 */
export function schemaVille(ville: PageVille) {
  const url = `${SITE}/services/creation-site-web-${ville.slug}`;

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": `${url}#service`,
        name: `Création de site web à ${ville.nom}`,
        description: ville.meta.description,
        serviceType: "Création de site web",
        /**
         * ECART AVEC LE PLAN, assume et signale ici.
         *
         * L'etape 3 de la tache 4 ecrivait provider: { "@id": `${SITE}/#person` }
         * et demandait de verifier cet identifiant contre le JSON-LD de
         * index.html. Verification faite : ce JSON-LD ne porte AUCUN "@id",
         * ni sur son noeud Person, ni ailleurs. La reference seule aurait donc
         * pointe dans le vide, et le prestataire du service se serait reduit a
         * une URL que rien ne resout.
         *
         * Le noeud est donc decrit ici, avec le meme identifiant stable que
         * celui prevu par le plan. La page devient autoportante, et le jour ou
         * index.html recevra son "@id", les deux declarations fusionneront
         * d'elles-memes au lieu de se contredire.
         */
        provider: {
          "@type": "Person",
          "@id": `${SITE}/#person`,
          name: "Tokam Darius",
          url: `${SITE}/`,
        },
        dateModified: ville.misAJour,
        areaServed: {
          "@type": "City",
          name: ville.nom,
          containedInPlace: { "@type": "AdministrativeArea", name: "Québec" },
        },
        url,
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        mainEntity: ville.faq.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.reponse },
        })),
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${url}#fil`,
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Accueil", item: `${SITE}/` },
          { "@type": "ListItem", position: 2, name: "Services", item: `${SITE}/services` },
          {
            "@type": "ListItem",
            position: 3,
            name: `Création de site web à ${ville.nom}`,
            item: url,
          },
        ],
      },
    ],
  };
}
